
import { h } from "preact"
import MultipleChoicePreviewComponent from "../previews/multiple-choice-preview.jsx";
import { check, minus, times } from "../../icons.js";

export default class MultipleChoiceReportComponent extends MultipleChoicePreviewComponent {

    responseCollector() {
        let scoringData = this.props.scoringData && Array.isArray(this.props.scoringData) ? this.props.scoringData : null;
        /**
         * @type {Object<string, {points: string}>}
         */
        let scoringDataByChoiceId = scoringData?.reduce((acc, sd) => {acc[sd.choice_id] = sd; return acc}, {}) || {};
        let choices = this.props.item.responseDeclaration.choices
        /**
         * @type {Array<number>}
         */
        let selectedChoiceIds = []
        if (this.props.item.responseType == "single-bubble" || this.props.item.responseType == "true-false") {
            selectedChoiceIds = this.props.studentResponse?.single_bubble?.choice_id !== undefined ? [this.props.studentResponse?.single_bubble?.choice_id] : []
        } else {
            selectedChoiceIds = this.props.studentResponse?.multiple_bubble?.choice_ids || []
        }

        let correctAnswers = this.correctAnswers();

        if (choices) {
            let sortedChoices = choices.sort((a, b) => { return a.ordinal > b.ordinal ? 1 : -1 })
            return <div class="response-collector multiple-choice">
                {sortedChoices.map((choice) => {
                    let isSelected = selectedChoiceIds.includes(Number(choice.id));
                    let status = this.statusForChoice(Number(choice.id), selectedChoiceIds, correctAnswers)
                    return <div class={`response ${status}`}>
                        <div class="label">
                            <button tabIndex={1} class={`bubble ${isSelected ? "selected" : ""}`} >{choice.identifier}</button>
                            {status == "correct" && <span class="status-icon correct" dangerouslySetInnerHTML={{ __html: check }}></span>}
                            {status == "incorrect" && <span class="status-icon incorrect" dangerouslySetInnerHTML={{ __html: times }}></span>}
                            {status == "partial" && <span class="status-icon partial" dangerouslySetInnerHTML={{ __html: minus }}></span>}
                        </div>
                        <div class="answer-container">
                            <div class="answer" dangerouslySetInnerHTML={{ __html: choice.body }}></div>
                        </div>
                        {scoringDataByChoiceId[String(choice.id)] ? <div class="points-container" title="Points">{scoringDataByChoiceId[String(choice.id)].points}</div> : null}
                    </div>
                })}
            </div>
        }
    }

    /**
     * 
     * @param {number} choiceId 
     * @param {number[]} selectedChoiceIds 
     * @param {number[][]} correctAnswers 
     * @returns string 
     */
    statusForChoice(choiceId, selectedChoiceIds, correctAnswers) {
        if (selectedChoiceIds.includes(choiceId)) {
            let scoringMode = this.props.item.correctResponse.scoring_mode || "all_or_nothing";
            if (scoringMode == "all_or_nothing") {
                return correctAnswers.find((ca) => numberArrayEqual(ca, selectedChoiceIds)) ? "correct" : "incorrect";
            } else if (scoringMode == "spread_points_evenly") {
                return (correctAnswers[0] || []).includes(choiceId) ? (this.isFullyCorrect(selectedChoiceIds, correctAnswers) ? "correct" : "partial") : "incorrect";
            } else if (scoringMode == "exact_matches") {
                return correctAnswers.find((ca) => numberArrayEqual(ca, selectedChoiceIds)) ? "correct" : this.isPartiallyCorrectExactMatches(selectedChoiceIds) ? "partial" : "incorrect";
            } else if (scoringMode == "point_associations") {
                return (this.props.item.correctResponse.point_associations || []).find((pa) => pa.choice_id == choiceId && pa.points > 0) ? "correct" : "incorrect";
            }
        } else {
            return "";
        }
    }


    /**
     * @param {number[]} selectedChoiceIds 
     * @param {number[][]} correctAnswers 
     * @returns boolean 
     */
    isFullyCorrect(selectedChoiceIds, correctAnswers) {
        return correctAnswers.find((ca) => numberArrayEqual(ca, selectedChoiceIds));
    }

    isPartiallyCorrectExactMatches(selectedChoiceIds) {
        let match = (this.props.item.correctResponse.definition || []).find((def) => numberArrayEqual(def.matches, selectedChoiceIds));
        if (match) {
            return match.score > 0;
        } else {
            return false;
        }

    }
}

/**
 * 
 * @param {number[]} arr1 
 * @param {number[]} arr2 
 */
function numberArrayEqual(arr1, arr2) {
    if (arr1.length != arr2.length) {
        return false;
    }

    return arr1.every((val, index) => arr2.includes(val));
}
